export default __webpack_public_path__ + "static/media/logo.7b28a8d7.png";